import { ButtonControlType } from 'tailwind/components/Button/Button.types';

export const getControlType = ({ href, isExternalLink, disabled }: { href?: string; isExternalLink?: boolean; disabled?: boolean }) => {
  // return a disabled button rather than a link when disabled, disabled on links is not supported
  if (!href || disabled) {
    return ButtonControlType.button;
  }

  if (isExternalLink) {
    return ButtonControlType.a;
  }

  return ButtonControlType.link;
};

export const getComponentProps = ({
  controlType,
  href,
  type,
  disabled
}: {
  controlType: ButtonControlType;
  href?: string;
  type?: string;
  isExternalLink?: boolean;
  disabled?: boolean;
}) => {
  if (controlType === ButtonControlType.button) {
    return { type: !type ? (ButtonControlType.button as const) : type, disabled };
  }

  if (controlType === ButtonControlType.a) {
    return { href: href };
  }

  return {};
};
